module.exports = __webpack_public_path__ + "img/Logo.ff3b6e69.svg";